import { motion } from 'framer-motion';

interface IconProps {
  className?: string;
}

interface Feature {
  title: string;
  description: string;
  icon: React.ComponentType<IconProps>;
  index: number;
}

const PricingTitle: React.FC<{ feature: Feature }> = ({ feature }) => {
    return (
      <motion.div
        key={feature.title}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 + feature.index * 0.1 }}
        className="bg-white/95 backdrop-blur-sm rounded-xl p-6 shadow-lg border border-white/50 text-center"
      >
        <div className="w-12 h-12 bg-gradient-primary rounded-xl flex items-center justify-center mx-auto mb-4 shadow-lg">
          <feature.icon className="w-6 h-6 text-white" />
        </div>
        <h3 className="text-lg font-semibold text-charcoal mb-2">{feature.title}</h3>
        <p className="text-sm text-slate-gray">{feature.description}</p>
      </motion.div>
    );
}

export default PricingTitle